import React from 'react';
import { SimpleForm, Create, TextInput, BooleanInput } from 'react-admin';
import { required } from 'ra-core';
import ScreenDescription from '../ScreenDescription';

const MessageTypeCreate = props => (
  <>
    <ScreenDescription>
      Os 5 tipos oficiais da Meta (marketing, utilidade, autenticação, serviço, janela livre) já vêm cadastrados. Só crie um novo
      se a Meta introduzir uma categoria de cobrança diferente. Depois de criar, defina o custo unitário na tela de edição.
    </ScreenDescription>
    <Create {...props}>
      <SimpleForm>
        <TextInput source="name" label="Nome" validate={required()} />
        <TextInput source="key" label="Chave" validate={required()} />
        <BooleanInput source="active" label="Ativo" defaultValue={true} />
      </SimpleForm>
    </Create>
  </>
);

export default MessageTypeCreate;
